import { formatGeolocation, parseLocationSearch } from 'utils'

export const getQsGeolocation = () => {
  const queryStringParams = parseLocationSearch()
  const { lat = null, lng = null } = queryStringParams
  if (lat && lng) {
    return formatGeolocation({ lat, lng }, 'queryString')
  }
  return null
}

const { search } = window.location

export default {
  previousLocation: {},
  query: {},
  geolocation: getQsGeolocation(),
  initialLocation: { search },
  gclidDependenciesReady: false,
  // storeIdReadingReady: false,
}
